import { Component, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { createValidator, getErrorFormatter } from '@sonofabit/ng-core';

// Register custom error formatters once at module load so hau-form-field can display them
if (!getErrorFormatter('maxDecimals')) {
  createValidator<unknown, { max: number }, []>('maxDecimals', {
    validator: () => null,
    message: (value, label) => `${label} darf maximal ${value.max} Dezimalstellen haben.`,
  });
}
if (!getErrorFormatter('invalidNumber')) {
  createValidator<unknown, true, []>('invalidNumber', {
    validator: () => null,
    message: (_value, label) => `${label} muss eine gültige Zahl sein.`,
  });
}

@Component({
  standalone: false,
  selector: 'wr-area-input',
  templateUrl: './area-input.component.html',
  styleUrls: ['./area-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AreaInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AreaInputComponent),
      multi: true,
    },
  ],
})
export class AreaInputComponent extends AbstractFormControl<number | undefined> implements Validator {

  onValueChange(v: number | null): void {
    this.value = v !== null && !isNaN(v) ? v : undefined;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const val = control.value;
    if (val === null || val === undefined || val === '') {
      return null;
    }
    const num = Number(val);
    if (isNaN(num)) {
      return { invalidNumber: true };
    }
    if (num < 0) {
      return { min: { min: 0, actual: num } };
    }
    const str = String(val);
    const dotIndex = str.indexOf('.');
    if (dotIndex !== -1 && str.length - dotIndex - 1 > 2) {
      return { maxDecimals: { max: 2, actual: str.length - dotIndex - 1 } };
    }
    return null;
  }
}
